module.exports = __webpack_public_path__ + "img/bz.b2bcf290.svg";